// QR block — factory + serializer. This is the single source of truth for
// what a QR block persists (see "Block capability contract" in
// ../PLAN.md). The grid never asserts this shape itself.
//
// Unlike text/image, a QR block is always square — a single `size` field
// drives both dimensions, not independent width/height, since a QR code
// distorted off-square won't scan.

let idCounter = 0;
const nextId = () => `qr_${Date.now()}_${idCounter++}`;

export const DEFAULT_QR_VALUE = 'https://www.sustainablysprouted.com/';

export function createQRBlock(overrides = {}) {
  return {
    id: nextId(),
    // Manually-typed URL/text for now — see blocks/qr-block.md "Composes
    // with" for the deferred, optional coupon-sourced value.
    value: DEFAULT_QR_VALUE,
    x: 0.1,
    y: 0.1,
    size: 0.85,
    // Appearance, matched to qrcode.react's QRCodeSVG props (level/
    // fgColor/bgColor/marginSize) — see blocks/qr-block.md "Editable
    // properties".
    ecLevel: 'M',
    fgColor: '#000000',
    bgColor: '#ffffff',
    marginModules: 3,
    // Whether this block's properties panel is collapsed. Persisted per
    // block (not localStorage, unlike other sidebar panels) since it's a
    // property of this specific block within this specific template, not
    // of the print designer UI in general — a localStorage key per block
    // would grow unbounded across templates with many blocks.
    collapsed: false,
    ...overrides,
  };
}

export function serializeQRBlock({ id, value, x, y, size, ecLevel, fgColor, bgColor, marginModules, collapsed }) {
  return { type: 'qr', id, value, x, y, size, ecLevel, fgColor, bgColor, marginModules, collapsed };
}
